<template>
  <div id="app">
    <NavbarMenu 
      @category-change="handleCategoryChange" 
      @search="handleSearch"
    />
    <main class="app-main">
      <PageLoader />
      <router-view />
    </main>
    <footer class="footer">
      <div class="footer-container">
        <div class="footer-section footer-brand">
          <img
            src="@/assets/logo_joao_brodt_preto.png"
            alt="Portal João Brodt"
            class="footer-logo"
          />
          <p>Seu portal de notícias sobre tecnologia, eventos e inovação.</p>
        </div>
        <div class="footer-section">
          <h4>Contato</h4>
          <p>contato@portaljoaobrodt.com.br</p>
        </div>
        <div class="footer-section">
          <h4>Redes Sociais</h4>
          <div class="social-links">
            <a
              href="https://www.linkedin.com/in/jo%C3%A3obrodt/"
              aria-label="LinkedIn"
              target="_blank"
              rel="noopener"
            >
              LinkedIn
            </a>
            <a
              href="https://github.com/JoaoBrodt"
              aria-label="GitHub"
              target="_blank"
              rel="noopener"
            >
              GitHub
            </a>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <p>&copy; 2025 Portal João Brodt. Todos os direitos reservados.</p>
      </div>
    </footer>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import PageLoader from './components/PageLoader.vue'

export default {
  name: 'App',
  components: {
    NavbarMenu: Navbar,
    PageLoader
  },
  methods: {
    handleCategoryChange(category) {
      const routes = {
        'EVENTOS': '/eventos',
        'TECNOLOGIA': '/tecnologia',
        'NOTÍCIAS': '/noticias'
      }
      if (routes[category]) {
        this.$router.push(routes[category])
      }
    },
    handleSearch(query) {
      if (query.trim()) {
        this.$router.push({
          path: '/buscar',
          query: { q: query }
        });
      }
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --brand-navy: #171d3a;
  --brand-navy-soft: #94abf9;
  --brand-sky: #94abf9;
  --brand-cloud: #e5e9fd;
  --brand-foam: #ffffff;
}

html,
body {
  background: var(--brand-navy);
  min-height: 100vh;
  scrollbar-width: thin;
  scrollbar-color: var(--brand-navy-soft) rgba(255, 255, 255, 0.1);
  font-family: 'DM Sans', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}
html::-webkit-scrollbar,
body::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
html::-webkit-scrollbar-track,
body::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.08);
}
html::-webkit-scrollbar-thumb,
body::-webkit-scrollbar-thumb {
  background: var(--brand-navy-soft);
  border-radius: 999px;
}

#app {
  font-family: 'DM Sans', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--brand-cloud);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-main {
  position: relative;
  flex: 1;
  width: 100%;
  margin: 0 auto;
}

.footer {
  margin-top: auto;
  background: var(--brand-foam);
  border-top: 1px solid rgba(23, 29, 58, 0.12);
  padding: 10px 0;
  box-shadow: 0 -12px 30px rgba(23, 29, 58, 0.08);
}

.footer-container {
  max-width: 1400px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 2.5rem;
  margin: 0 40px;
}

.footer-section {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.footer-section h3 {
  font-size: 24px;
  margin-bottom: 1rem;
  color: var(--brand-navy);
}

.footer-brand {
  display: flex;
  flex-direction: column;
}

.footer-logo {
  width: 120px;
}

.footer-section h4 {
  font-size: 18px;
  color: var(--brand-navy);
}

.footer-section p {
  color: rgba(0, 35, 73, 0.68);
  line-height: 1.6;
  margin-bottom: 0.5rem;
}

.social-links {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.social-links a {
  color: rgba(0, 35, 73, 0.7);
  text-decoration: none;
  transition: color 0.3s ease;
}

.social-links a:hover {
  color: var(--brand-navy);
}

.footer-bottom {
  text-align: center;
  padding-top: 10px;
  border-top: 1px solid rgba(0, 35, 73, 0.12);
  color: rgba(0, 35, 73, 0.62);
  font-size: 14px;
}

@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .social-links {
    justify-content: center;
  }

  .footer-brand {
    align-items: center;
    text-align: center;
  }

  .footer-logo {
    margin: 0 auto;
  }
}
</style>
